import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

/**
 * Mirrors the API: SAP export states are an attribute of the customer, so whoever may read customers may read
 * their export states (scoped by the same `CG.*` roles). Only masterdata administrators manage them.
 */
export function setCustomerSapExportPermissions(user: User, builder: AbilityBuilder<AppAbility>): void {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.MasterdataAdministrator)) {
    can(Action.Manage, "CustomerSapExport");
    return;
  }

  if (user.roles.includes(SubjectRoles.Int) || user.roles.includes(SubjectRoles.AceUser)) {
    can(Action.Read, "CustomerSapExport");
  }
}
